import { useTranslation } from '@crew/modules/i18n'
import classNames from 'classnames'
import { FC, memo } from 'react'
import { isWeekend } from 'utils/date'

type DateCellProps = {
  date: Date
}

// Custom template for the head cells on Scheduler
export const DateCell: FC<DateCellProps> = memo((props) => {
  const { t } = useTranslation()
  return (
    <div
      className={classNames(
        'w-full h-full flex items-center justify-center',
        // Make the background color for the cell of weekend is gray
        isWeekend(props.date) && 'crew-scheduler-weekend'
      )}
    >
      {t('format.weekday', {
        value: props.date,
      })}
    </div>
  )
})
